import moment from "moment";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { EditLink, ScheduleLink } from "../_components/AdminRowActions";

const VehicleItem = ({
  vehicle: { _id, vehiclename, vehicletype, registration, isactive, date },
  count,
}) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{vehiclename}</td>
    <td className={cellClass}>{vehicletype}</td>
    <td className={cellClass}>{registration}</td>
    <td className={cellClass}>
      <AdminBadge tone={isactive ? "success" : "neutral"}>{isactive ? "Active" : "Inactive"}</AdminBadge>
    </td>
    <td className={`${cellClass} tw:whitespace-nowrap`}>{moment(date).locale("en").format("YYYY/MM/DD")}</td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <ScheduleLink to={`/admin/vehiclelist/${_id}/schedule`} label="View vehicle schedule" />
        <EditLink to={`/admin/vehiclelist/edit/${_id}`} label="Edit vehicle" />
      </AdminRowActions>
    </td>
  </tr>
);

export default VehicleItem;
